export default function isPending(collectionType, id, state) {
  const key = `${collectionType}/`;

  return !!state.operation.find(r => r.indexOf(key) !== -1 && r.indexOf(id) !== -1);
}
